export const navSections = [
  {
    title: "",
    items: [{ label: "Dashboard", path: "/dashboard", icon: "ri-dashboard-3-line" }],
  },
  {
    title: "Operations",
    items: [
      { label: "Travel & Budget", path: "/travel", icon: "ri-flight-takeoff-fill", badge: 8 },
      { label: "Training", path: "/training/request", icon: "ri-graduation-cap-fill" },
      {
        label: "Claims",
        icon: "ri-file-list-3-line",
        badge: 8,
        children: [
          { label: "My Claims", path: "/claim", exact: true },
          { label: "Credit Card Statement", path: "/claim/credit-card-statements" },
        ],
      },
      { label: "Approvals", path: "/approvals", icon: "ri-checkbox-circle-line", badge: 8 },
    ],
  },
  {
    title: "Administration",
    items: [
      { label: "Finance", path: "/finance", icon: "ri-bank-card-fill" },
      { label: "Reports", path: "/report", icon: "ri-pie-chart-2-fill" },
      {
        label: "Administration",
        icon: "ri-settings-3-fill",
        children: [
          { label: "Users", path: "/users" },
          { label: "Roles & Permission", path: "/role" },
          { label: "Departments", path: "/departments" },
          { label: "Designation", path: "/designation" },
          { label: "Training Categories", path: "/tcategories" },
          { label: "Budget Codes", path: "/budget" },
          { label: "Credit Cards", path: "/credit-cards" },
          { label: "Claim Policy", path: "/claimpolicy" },
          { label: "Audit Trail", path: "/audit" },
        ],
      },
    ],
  },
];

export const pageCatalog = {
  dashboard: {
    title: "Dashboard",
    subtitle: "Track travel, claims, training, and approvals in one place.",
    chips: ["Pending travel", "Pending claims", "Approval queue"],
    metrics: [
      { label: "Travel Requests", value: "18", note: "4 pending approval" },
      { label: "Claims", value: "12", note: "3 pending finance" },
      { label: "Approvals", value: "27", note: "5 urgent items" },
      { label: "Finance", value: "9", note: "2 awaiting review" },
    ],
    panels: [
      {
        title: "Recent travel requests",
        rows: [
          ["TR-2025-0421", "Singapore", "Pending Approval"],
          ["TR-2025-0420", "Kuala Lumpur", "Draft"],
          ["TR-2025-0419", "Bangkok", "Submitted"],
          ["TR-2025-0418", "Kuching", "Approved"],
        ],
      },
      {
        title: "Recent claims",
        rows: [
          ["CL-2025-0330", "TR-2025-0421", "RM 1,250.00"],
          ["CL-2025-0329", "TR-2025-0420", "RM 820.00"],
          ["CL-2025-0328", "TR-2025-0419", "RM 1,100.00"],
          ["CL-2025-0327", "TR-2025-0418", "RM 2,340.00"],
        ],
      },
    ],
  },
  travel: {
    title: "Travel",
    subtitle: "Create, review, and manage travel requests and amendments.",
    chips: [
      { label: "New trip", path: "/travel/create/step-1" },
      { label: "Amend travel", path: "/travel/TR-2025-0421" },
      { label: "Step-by-step flow", path: "/travel/create/step-1" },
    ],
    metrics: [
      { label: "Drafts", value: "6", note: "Waiting to continue" },
      { label: "Submitted", value: "11", note: "Sent for approval" },
      { label: "Approved", value: "21", note: "Ready for claim" },
      { label: "Amendments", value: "4", note: "Needs travel update" },
    ],
    panels: [
      {
        title: "Travel flow",
        rows: [
          ["Step 1", "Trip details"],
          ["Step 2", "Flight and accommodation"],
          ["Step 3", "Participants and routing"],
          ["Step 4", "Costs and budget"],
          ["Step 5", "Review and submit"],
        ],
      },
      {
        title: "Open requests",
        rows: [
          ["TR-2025-0421", "Singapore", "Pending Approval"],
          ["TR-2025-0420", "Kuala Lumpur", "Draft"],
          ["TR-2025-0419", "Bangkok", "Submitted"],
          ["TR-2025-0418", "Kuching", "Approved"],
        ],
      },
    ],
  },
  training: {
    title: "Training",
    subtitle: "Manage request lists, evaluation forms, and training categories.",
    chips: ["Request list", "Create training", "Evaluations"],
    metrics: [
      { label: "Requests", value: "14", note: "2 awaiting action" },
      { label: "Draft training", value: "5", note: "Unsubmitted" },
      { label: "Evaluations", value: "9", note: "Ready for review" },
      { label: "Categories", value: "8", note: "Reusable labels" },
    ],
    panels: [
      {
        title: "Training requests",
        rows: [
          ["TRN-3001", "Customer service", "Submitted"],
          ["TRN-3002", "Safety briefing", "Draft"],
          ["TRN-3003", "Leadership", "Approved"],
          ["TRN-3004", "System onboarding", "Pending Approval"],
        ],
      },
      {
        title: "Evaluations",
        rows: [
          ["EV-2201", "Customer service", "Completed"],
          ["EV-2202", "Safety briefing", "Pending"],
          ["EV-2203", "Leadership", "Completed"],
          ["EV-2204", "System onboarding", "Pending"],
        ],
      },
    ],
  },
  claim: {
    title: "Claims",
    subtitle: "Select a claim type and continue through the submission steps.",
    chips: ["Cash", "Mileage", "Travel", "Meal allowance"],
    metrics: [
      { label: "Cash claims", value: "7", note: "Ready to submit" },
      { label: "Mileage claims", value: "3", note: "Awaiting receipt" },
      { label: "Travel claims", value: "4", note: "Linked to trips" },
      { label: "Meal claims", value: "2", note: "Short-form items" },
    ],
    panels: [
      {
        title: "Claim modules",
        rows: [
          ["Cash", "Everyday reimbursement"],
          ["Credit card", "Corporate card settlement"],
          ["Local travel", "Mileage and local transport"],
          ["Overseas travel", "Trip-based reimbursement"],
        ],
      },
      {
        title: "Recent claims",
        rows: [
          ["CL-2025-0330", "TR-2025-0421", "Pending Approval"],
          ["CL-2025-0329", "TR-2025-0420", "Pending Finance"],
          ["CL-2025-0328", "TR-2025-0419", "Draft"],
          ["CL-2025-0327", "TR-2025-0418", "Approved"],
        ],
      },
    ],
  },
  approvals: {
    title: "Approvals",
    subtitle: "Review requests waiting for sign-off.",
    chips: ["Travel approvals", "Claim approvals", "Budget reallocation"],
    metrics: [
      { label: "Waiting approval", value: "27", note: "Across all queues" },
      { label: "Urgent", value: "6", note: "Needs same-day action" },
      { label: "Approved today", value: "11", note: "Completed tasks" },
      { label: "Returned", value: "2", note: "Needs revision" },
    ],
    panels: [
      {
        title: "Approval queue",
        rows: [
          ["TR-2025-0421", "Travel", "Pending Approval"],
          ["CL-2025-0330", "Claim", "Pending Approval"],
          ["BG-2025-0011", "Budget", "Pending Finance"],
          ["TRN-2202", "Training", "Pending Approval"],
        ],
      },
      {
        title: "Action summary",
        rows: [
          ["Approve", "Move item forward"],
          ["Return", "Request revision"],
          ["Reject", "Stop the workflow"],
          ["Comment", "Add notes for the next reviewer"],
        ],
      },
    ],
  },
  users: {
    title: "Users",
    subtitle: "Manage staff accounts, roles, and portal access.",
    chips: ["Active users", "Invite staff", "Permissions"],
    metrics: [
      { label: "Users", value: "128", note: "94 active today" },
      { label: "Admins", value: "8", note: "Full access" },
      { label: "Managers", value: "19", note: "Approval rights" },
      { label: "Pending invites", value: "4", note: "Awaiting login" },
    ],
    panels: [
      {
        title: "User list",
        rows: [
          ["Aisyah", "Finance", "Active"],
          ["Daniel", "Operations", "Active"],
          ["Siti", "HR", "Pending invite"],
          ["Jason", "IT", "Active"],
        ],
      },
      {
        title: "Access summary",
        rows: [
          ["Staff", "Travel + claim submission"],
          ["Manager", "Approval rights"],
          ["Finance", "Claim verification"],
          ["Admin", "System configuration"],
        ],
      },
    ],
  },
  role: {
    title: "Roles",
    subtitle: "Define role names and permission sets.",
    chips: ["System administrator", "Department manager", "Finance officer"],
    metrics: [
      { label: "Roles", value: "12", note: "3 core roles" },
      { label: "Permissions", value: "48", note: "Grouped access rules" },
      { label: "Assigned users", value: "128", note: "Mapped to roles" },
      { label: "Custom roles", value: "5", note: "Locally managed" },
    ],
    panels: [
      {
        title: "Role list",
        rows: [
          ["System Administrator", "Full system access"],
          ["Department Manager", "Approve team requests"],
          ["Finance Officer", "Verify claims"],
          ["Staff", "Submit own requests"],
        ],
      },
      {
        title: "Permission matrix",
        rows: [
          ["Travel", "Create, view, amend"],
          ["Training", "Create, evaluate"],
          ["Claims", "Submit, edit, review"],
          ["Admin", "Users, roles, audit"],
        ],
      },
    ],
  },
  designation: {
    title: "Designation",
    subtitle: "Maintain official job titles used across the portal.",
    chips: ["Job title", "Team", "Approval chain"],
    metrics: [
      { label: "Designations", value: "16", note: "Company-wide titles" },
      { label: "Departments", value: "9", note: "Linked to titles" },
      { label: "Approvers", value: "24", note: "Assigned managers" },
      { label: "Vacant", value: "3", note: "Open positions" },
    ],
    panels: [
      {
        title: "Designation list",
        rows: [
          ["Senior Executive", "Operations"],
          ["Assistant Manager", "Finance"],
          ["Officer", "HR"],
          ["Director", "Leadership"],
        ],
      },
      {
        title: "Workflow impact",
        rows: [
          ["Travel approvals", "Uses reporting line"],
          ["Claim approvals", "Uses department"],
          ["Training", "Uses team owner"],
          ["Audit", "Tracks history"],
        ],
      },
    ],
  },
  tcategories: {
    title: "Training Categories",
    subtitle: "Group trainings into reusable categories.",
    chips: ["Leadership", "Compliance", "Technical skills"],
    metrics: [
      { label: "Categories", value: "8", note: "Reusable groups" },
      { label: "Active", value: "7", note: "Visible to users" },
      { label: "Archived", value: "1", note: "Hidden from forms" },
      { label: "Linked trainings", value: "34", note: "Across all categories" },
    ],
    panels: [
      {
        title: "Category list",
        rows: [
          ["Leadership", "High impact development"],
          ["Compliance", "Policy and regulation"],
          ["Technical", "System and tooling"],
          ["Wellbeing", "People support"],
        ],
      },
      {
        title: "Usage",
        rows: [
          ["Create training", "Select a category"],
          ["Evaluate training", "Filter by category"],
          ["Reports", "Summarise by type"],
          ["Audit", "Track changes"],
        ],
      },
    ],
  },
  audit: {
    title: "Audit Log",
    subtitle: "Review tracked actions and system events.",
    chips: ["User changes", "Approval actions", "Security events"],
    metrics: [
      { label: "Today", value: "43", note: "Logged entries" },
      { label: "This week", value: "219", note: "Audit records" },
      { label: "Admin actions", value: "17", note: "Config changes" },
      { label: "Security", value: "2", note: "Flagged items" },
    ],
    panels: [
      {
        title: "Recent events",
        rows: [
          ["Aisyah", "Updated role", "09:12"],
          ["Daniel", "Approved travel", "10:21"],
          ["Siti", "Submitted claim", "11:05"],
          ["System", "Login success", "11:30"],
        ],
      },
      {
        title: "Event types",
        rows: [
          ["Create", "New requests"],
          ["Update", "Field changes"],
          ["Approve", "Workflow actions"],
          ["Delete", "Removed records"],
        ],
      },
    ],
  },
  login: {
    title: "Welcome Back",
    subtitle: "Sign in to the BESarawak Staff Portal.",
  },
};

export const getPageConfig = (key) => pageCatalog[key] || pageCatalog.dashboard;
